<template lang="pug">
v-container.instance-history
  v-row
    v-col
      h2.primary--text {{$t('Schema.History')}}
  app-change-log-timeline(@action="showMore", v-bind="{ changes, showAction, loading }")
</template>

<script>
import axios from 'axios'
import GeodisDiff from '@@/components/Diff'
import { get, setWith, reduce, forEach, toArray, map, findIndex } from 'lodash';

export default {
  components: {
    GeodisDiff
  },
  props: ['instance'],
  data () {
    return {
      entitySpecialCases: {
        Order: {
          PartyFrom: 'simpleNameChange',
          PartyTo: 'simpleNameChange',
          Status: 'simpleNameChange',
        }
      },
      changes: [],
      pagination: {},
      loading: true,

    }
  },
  computed : {
    showAction() {
      return this.pagination && this.pagination.page < this.pagination.totalPages;
    },
  },
  methods: {
    showMore() {
      // this.changes = [...this.changes, ...this.mockChanges];
      this.load((this.pagination.page || 0) + 1);
    },
    // Receives an array of changes from back, transform each change like folows:
    /**
     * {
     *  entity, date, userName, uid, details: [Array of groupChanges]
     * }
    */
    transformChanges(changes) {
      if (!changes) return [];

      //Make details array with groupChangesObject like follows:
      /*
        [{ label, changes }, ...]
      */
      const arrayOfChanges = changes.map(change => {
        const details = this.getDetails(change, null, this.instance._Entity);

        // Return groupChangeObject
        return ({
          userName: get(change, 'userName'),
          date: get(change, 'date'),
          entity: get(change, 'entity'),
          uid: get(change, 'uid'),
          details,
        });
      });

      return arrayOfChanges;
    },
    // method to reuse the different groups on a change
    getDetails(change, path = null, entity = '') {
      const fromObject = get(change, 'from', {});
      const toObject = get(change, 'to', {});

      // Extract all root changes (ExtraData and OrderLines changes are excluded here)
      const reduced = [];
      this.addAttributeChange(reduced, fromObject, 'from', 'to', entity);
      this.addAttributeChange(reduced, toObject, 'to', 'from', entity);

      // Extract ExtraData Changes
      const extraDataChanges = this.getExtraDataChanges(fromObject, toObject);
      const orderLineChanges = this.extractOrderLines(fromObject, toObject);
      const contentChanges = this.extractContent(fromObject, toObject);
      const expressionChanges = this.extractExpressions(fromObject, toObject);
      // Join extraData changesGroups, root changeGroup, orderLine changeGroups
      const details = [
        {
          label: path || 'root',
          changes: reduced,
        },
        ...extraDataChanges,
        ...orderLineChanges,
        ...contentChanges,
        ...expressionChanges,
      ];

      return details;
    },
    simpleNameChange(obj = {}) {
      return obj.Name || '';
    },
    formatCheck(val) {
      if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d*Z/.test(val)) return this.$formattedDate(val);
      return val;
    },
    addAttributeChange(arrayChanges = [], changeObject = {}, groupPath = 'from', nonUsedPath = 'to', entity = '') {
      forEach(changeObject, (val, key) => {
        if (key != 'ExtraData' && key != 'OrderLines' && key != 'uid' && key != 'Content' && key != 'Expression') {
          const index = findIndex(arrayChanges, ['label', this.$ucfirst(key)]);

          let treatedVal = val;
          if (this.entitySpecialCases[entity] && this.entitySpecialCases[entity][key]) {
            treatedVal = this[this.entitySpecialCases[entity][key]](val);
          }

          if (index != -1) {
            arrayChanges[index] = { ...arrayChanges[index], [groupPath]: this.formatCheck(treatedVal) };
          } else {
            arrayChanges.push({ label: this.$ucfirst(key), [groupPath]: this.formatCheck(treatedVal), [nonUsedPath]: '' });
          }
        }
      })
    },
    extractOrderLines(fromObject = {}, toObject = {}) {
      const getFromOL = get(fromObject, 'OrderLines', []);
      const getToOL = get(toObject, 'OrderLines', []);

      const orderLineChanges = [];

      this.addOrderLinesChanges(orderLineChanges, getFromOL, 'from', 'to');
      this.addOrderLinesChanges(orderLineChanges, getToOL, 'to', 'from');

      const changeDetails = map(orderLineChanges, change => {
        return this.getDetails(change, `OrderLine - ${change.Uid}`, 'OrderLine');
      });

      const orderLineChangeGroups = reduce(changeDetails, (res, array) => {
        return [...res, ...array];
      }, [])

      return orderLineChangeGroups;
    },
    addOrderLinesChanges(arrayOL, nonGroupedOL = [], groupPath = 'from', nonUsedPath = 'to') {
      forEach(nonGroupedOL, ol => {
        const index = findIndex(arrayOL, ['Uid', ol.Uid]);
        if (index != -1) {
          arrayOL[index] = { ...arrayOL[index], [groupPath]: {...ol} }
        } else {
          arrayOL.push({ Uid: ol.Uid, [groupPath]: {...ol}, [nonUsedPath]: {} })
        }
      })
    },
    extractExpressions(fromObject = {}, toObject = {}) {
      const getFromExpression = get(fromObject, 'Expression', "[]");
      const getToExpression = get(toObject, 'Expression', "[]");

      const expressionChanges = [];

      this.addExpressionsChanges(expressionChanges, JSON.parse(getFromExpression), 'from', 'to');
      this.addExpressionsChanges(expressionChanges, JSON.parse(getToExpression), 'to', 'from');

      const changeDetails = map(expressionChanges, change => {
        return this.getDetails(change, `Expression - ${change.Uid}`, 'Expression');
      });

      const expressionChangeGroups = reduce(changeDetails, (res, array) => {
        return [...res, ...array];
      }, [])

      return expressionChangeGroups;
    },
    addExpressionsChanges(arrayExp, nonGroupedExpression = [], groupPath = 'from', nonUsedPath = 'to') {
      forEach(nonGroupedExpression, (exp, i) => {
        const index = findIndex(arrayExp, ['Uid', i]);
        if (index != -1) {
          arrayExp[index] = { ...arrayExp[index], [groupPath]: {...exp} }
        } else {
          arrayExp.push({ Uid: i, [groupPath]: {...exp}, [nonUsedPath]: {} })
        }
      })
    },
    extractContent(fromObject = {}, toObject = {}) {
      const getFromContent = get(fromObject, 'Content', {});
      const getToContent = get(toObject, 'Content', {});

       // If 'getFromContent' or 'getToContent' is null or an empty string, set it to an empty JSON object string.
      const safeFromContent = (getFromContent === null || getFromContent === '') ? '{}' : getFromContent;
      const safeToContent = (getToContent === null || getToContent === '') ? '{}' : getToContent;

      if (_.isEmpty(safeFromContent) && _.isEmpty(safeToContent)) return [];

      try {
        // Try to parse 'safeFromContent' and 'safeToContent' as JSON and pass them to 'getDetails'
        return this.getDetails({ from: JSON.parse(safeFromContent), to: JSON.parse(safeToContent) }, 'Content') || [];
      } catch (e) {
        return [];
      }
    },
    // Each Extra Data Field could appear at fromObject or toObject or both
    // Use first a dictionary to collect all data, then convert each extraData group to changeGroup format
    getExtraDataChanges(fromObject = {}, toObject = {}) {
      const changesFrom = get(fromObject, 'ExtraData', []);
      const changesTo = get(toObject, 'ExtraData', []);
      const myExtraDataDictionary = this.getExtraDataDictionary(changesFrom, changesTo);
      const groupChangesArray = map(myExtraDataDictionary, (changedExtraFields, group) => {
        const changesArray = toArray(changedExtraFields);
        return ({ label: group, changes: changesArray });
      });
      return groupChangesArray;
    },
    // Use same dictionary and extract changes from both objects
    getExtraDataDictionary(changesFrom, changesTo) {
      const extrasDictionary = {};
      this.addExtraData(extrasDictionary, changesFrom, 'from', 'to');
      this.addExtraData(extrasDictionary, changesTo, 'to', 'from');
      return extrasDictionary;
    },
    // Use a method that mutates original dictionary prop
    // Find if the extraField change exists in the dictionary, else use empty searchedChangeType as empty string
    // Add new typeOfChange ('from' or 'to') to extraField change and add it to the dictionary using the extraFieldId
    // Format:
    // { GroupName: { extraFieldId: { label, from: '', to: '', type }}}
    // EX: { OrderExtras: { 442: { label: 'isHandi', from '', to: 'yes', type: String }}}
    addExtraData(dictionary, changes, typeOfChange, searchedChangeType) {
      forEach(changes, change => {
        const { Key, Type, Value, ExtraFieldId } = change;
        const [groupName, label] = Key.split('.');
        const extraFieldPath = `${groupName}.${ExtraFieldId}`;
        const foundChangeObject = get(dictionary, extraFieldPath, { [searchedChangeType]: '' });
        setWith(dictionary, extraFieldPath, { ...foundChangeObject, label, [typeOfChange]: Value, Type }, Object);
      });
    },
    async load(page = 1) {
      try {
        this.loading = true;
        let rest;
        let newChanges;
        ({ data: { data: newChanges, ...rest } } = await axios.get('EntityLog', { params: {
          withoutGlobalBusinessScope: true,
          page,
          where: [
            `x => x.Entity == "${this.instance._Entity}"`,
            `x => (x.EntityId == "${this.instance.id}" || x.EntityUid == "${this.instance.uid}")`,
          ],
        } }));

        // Each time you call the newChanges, transformThem before adding to array
        let newFormattedChanges = this.transformChanges(newChanges);
        this.changes = [...this.changes, ...newFormattedChanges];
        this.pagination = rest;
      } catch (e) {
        console.log(this.$cleanString(e))
      } finally {
        this.loading = false
      }
    },
  },
  async created () {
    this.load();
  }
}
</script>
